import * as memoMessageType from './resultOfConsiderType'
import useMemomessageTerminate from './useResultOfConsider'

import Grid from '@material-ui/core/Grid'
import { Form } from 'react-final-form'
import arrayMutators from 'final-form-arrays'
import { memorandumTopic } from '../../../../../../constants/constants'
import useTranslate from '../../../../../../i18n/useTranslate'
import PageAction from '../../pageAction'
import Dialog from '../../../../../../control/dialog/dialog'
import MyAccordion from '../../../../../../control/accordion/accordion'
import RichTextEditor from '../../../../../../control/richTextEditor/richTextEditor'
// import UploadDocCtrl from '../../../shareUI/uploadDoc/uploadDoc'
import UploadDoc from '../../../../shareUI/uploadDoc/uploadDoc'
import constSubmittedStatus from '../../../../../../constants/submittedStatus'
import constSubmittedStep from '../../../../../../constants/submittedStep'
import { approveStatusREC1, approveStatusREC2 } from '../../../../../../constants/approveStatus'

//View
const MemoMessageView = (props: memoMessageType.MemomessageViewType) => {
    const {
        formRef,
        isViewMode,
        initialValues,
        projectData,
        configDialog,
        onRefDialog,
        onClickBackToSearch,
        initialMemorandumFile,
        initialSuggestionNotice,
    } = props

    const translate = useTranslate()

    //มีการลงนามไปแล้ว
    const isSignMemoMessage: boolean =
        projectData?.stepID === constSubmittedStep.sign &&
        projectData?.submittedStatusInfo?.value === constSubmittedStatus.complete

    const isNotShowComment =
        initialValues?.approveStatus?.value === approveStatusREC1.acknowledgeAndDonotTakeAnyaAction.toString() ||
        initialValues?.approveStatus?.value === approveStatusREC2.acknowledgeAndDonotTakeAnyaAction.toString()

    return (
        <Form
            onSubmit={() => {}}
            initialValues={{ ...initialValues, memorandumFile: initialMemorandumFile }}
            mutators={{
                ...arrayMutators,
            }}
            keepDirtyOnReinitialize={true}
        >
            {(formProps) => {
                formRef.current = formProps
                return (
                    <>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={12} lg={12}>
                                <MyAccordion title={translate.get('LABEL.NOTIFY_REVIEW_OUTCOME')}>
                                    <Grid item xs={12} md={12} lg={12}>
                                        {translate.get('LABEL.ETHIC_REVIEW_OUTCOME')} :{' '}
                                        {translate.languageStore.currentLanguage === translate.languageKey.th
                                            ? initialValues?.approveStatus?.label
                                            : initialValues?.approveStatus?.label}
                                    </Grid>
                                </MyAccordion>
                            </Grid>

                            {!isNotShowComment && (
                                <Grid item xs={12}>
                                    <MyAccordion title={translate.get('LABEL.SUGGESTION_NOTICE')}>
                                        <Grid item xs={12} md={12} lg={12}>
                                            <RichTextEditor
                                                name={`suggestionNotice`}
                                                initialRichTextEditor={initialSuggestionNotice}
                                                disabled={isViewMode}
                                                isHideToolbar={isViewMode}
                                            />
                                        </Grid>
                                    </MyAccordion>
                                </Grid>
                            )}

                            {isSignMemoMessage && (
                                <Grid item xs={12} md={12} lg={12}>
                                    <UploadDoc
                                        name={'memorandumFile'}
                                        initialData={initialMemorandumFile}
                                        documentTitleList={memorandumTopic}
                                        title={translate.get('LABEL.MEMO_MESSAGE_DOC')}
                                        isViewMode={true}
                                        disabledBtn={true}
                                        // onClickOpenFile={onClickOpenFile}
                                    />
                                </Grid>
                            )}
                            {!isViewMode && (
                                <Grid item xs={12}>
                                    <PageAction
                                        onClickSaveDraft={() => {
                                            formProps.form.change('submitType', 'draft')
                                            formProps.handleSubmit()
                                        }}
                                        onClickSave={() => {
                                            formProps.form.change('submitType', 'save')
                                            formProps.handleSubmit()
                                        }}
                                        onClickClose={onClickBackToSearch}
                                    />
                                </Grid>
                            )}
                        </Grid>
                        {/* <FormSpy subscription={{ values: true, dirty: true }} onChange={onDirtyChange} /> */}
                        <Dialog onRef={onRefDialog} {...configDialog} />
                    </>
                )
            }}
        </Form>
    )
}

//Controller
const MemomessageCtrl = (props: memoMessageType.MemomessageCtrlType) => {
    const useMemomessageTerminateModel = useMemomessageTerminate(props)
    return <MemoMessageView {...useMemomessageTerminateModel} {...props} />
}
export default MemomessageCtrl
